exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* prevents bg color from leaking outside the border */\n\n/* Override Bootstrap buttons */\n\n.popover.hover {\n  font-family: \"Rubik\", sans-serif;\n  max-width: 300px;\n  width: 300px;\n  z-index: 3;\n}\n\n.popover.hover .hover-separator {\n  margin: 10px 0;\n}\n\n.popover.hover .hover-strong {\n  font-weight: 500;\n}\n\n.popover.hover table td:nth-child(2) {\n  max-width: 190px;\n}\n\n.disabled-link:hover {\n  color: #777777 !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/hover.scss
// module id = 576
// module chunks = 0